import $axios from "../../api";
import FileSaver from "file-saver";

const PREFIX = "website/article-blog";

const state = {
	isLoading: false,
	createLoading: false,
	errors: {},
	isSuccess: false,
	list: [],
	page: 1,
	detail: null,
};

const mutations = {
	SET_LOADING(state, payload) {
		state.isLoading = payload;
	},
	SET_ERRORS(state, payload) {
		state.errors = payload;
	},
	SET_SUCCESS(state, payload) {
		state.isSuccess = payload;
	},
	SET_LIST(state, payload) {
		state.list = payload;
	},
	SET_PAGE(state, payload) {
		state.page = payload;
	},
	SET_CREATE_LOAD(state, payload) {
		state.createLoading = payload;
	},
	SET_DETAIL(state, payload) {
		state.detail = payload;
	},
};

const actions = {
	getList({ commit, state, rootState, dispatch }, payload) {
		commit("SET_LOADING", true);

		return new Promise((resolve) => {
			$axios
				.get(
					`${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
				)
				.then((response) => {
					commit("SET_LIST", response.data.data);
					commit("SET_LOADING", false);
				})
				.catch((error) => {
					commit("SET_LOADING", false);
					dispatch("Main/globalSweetAlert", error.response, { root: true });
				});
		});
	},
	getDetail({ commit, dispatch }, id) {
		commit("SET_LOADING", true);

		return new Promise((resolve) => {
			$axios
				.get(`${PREFIX}/view${id}`)
				.then((res) => {
					commit("SET_DETAIL", res.data.data);
					commit("SET_LOADING", false);
				})
				.catch((error) => {
					commit("SET_LOADING", false);
					dispatch("Main/globalSweetAlert", error.response, { root: true });
				});
		});
	},
	createData({ commit, state, dispatch }, payload) {
		commit("SET_SUCCESS", false);
		commit("SET_CREATE_LOAD", true);
		commit("SET_ERRORS", {});

		return new Promise((resolve) => {
			$axios
				.post(`${PREFIX}/create`, payload)
				.then((response) => {
					commit("SET_CREATE_LOAD", false);
					commit("SET_SUCCESS", true);
					console.log(1);
					console.log(response);
				})
				.catch((error) => {
					console.log(2);
					console.log(error);
					console.log(error.response.data.errors);
					commit("SET_ERRORS", error.response.data.errors);
					commit("SET_CREATE_LOAD", false);
					commit("SET_SUCCESS", false);

					dispatch("Main/globalSweetAlert", error.response, { root: true });
				});
		});
	},
	updateData({ commit, state, dispatch }, payload) {
		commit("SET_SUCCESS", false);
		commit("SET_CREATE_LOAD", true);

		return new Promise((resolve) => {
			$axios
				.post(`${PREFIX}/update`, payload)
				.then((response) => {
					commit("SET_CREATE_LOAD", false);
					commit("SET_SUCCESS", true);
				})
				.catch((error) => {
					commit("SET_ERRORS", error.response.data.errors);
					commit("SET_CREATE_LOAD", false);
					commit("SET_SUCCESS", false);

					dispatch("Main/globalSweetAlert", error.response, { root: true });
				});
		});
	},
	showHide({ commit, dispatch }, payload) {
		commit("SET_SUCCESS", false);

		return new Promise((resolve) => {
			$axios
				.post(`${PREFIX}/showhide`, payload)
				.then((response) => {
					commit("SET_SUCCESS", true);

					dispatch(
						"Main/globalSuccessSweetAlert",
						response.data.message,
						{ root: true }
					);
				})
				.catch((error) => {
					commit("SET_SUCCESS", false);

					dispatch("Main/globalSweetAlert", error.response, { root: true });
				});
		});
	},
	isPublish({ commit, dispatch }, payload) {
		commit("SET_SUCCESS", false);

		return new Promise((resolve) => {
			$axios
				.post(`${PREFIX}/ispublish`, payload)
				.then((response) => {
					commit("SET_SUCCESS", true);

					dispatch(
						"Main/globalSuccessSweetAlert",
						response.data.message,
						{ root: true }
					);
				})
				.catch((error) => {
					commit("SET_SUCCESS", false);

					dispatch("Main/globalSweetAlert", error.response, { root: true });
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
